import React from 'react';
import { Popup } from 'semantic-ui-react';
import { GREATER_OF_CATEGORIES } from '../../../constants';

/**
 * Badge component for displaying greater_of_category on Greater Of contract types
 * Styled like notification count badges - red background with white text
 * Shows detailed description on hover
 */
const GreaterOfBadge = ({ category }) => {
    if (!category || category.toString().toUpperCase() === 'NOT APPLICABLE' || category.toString().toUpperCase() === 'NULL') return null;
    
    // Normalize category to uppercase, keep the exact category passed
    const normalizedCategory = category.toString().toUpperCase();
    const categoryInfo = GREATER_OF_CATEGORIES[normalizedCategory];
    
    // If category info not found, display the badge without tooltip
    if (!categoryInfo) {
        return <span className="category-label">{normalizedCategory}</span>;
    }
    
    const tooltipContent = (
        <div>
            <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{categoryInfo.name}</div>
            <div style={{ marginBottom: '5px' }}>{categoryInfo.description}</div>
            <div style={{ fontSize: '11px', fontStyle: 'italic' }}>
                <strong>Formula:</strong> {categoryInfo.formula}
            </div>
            <div style={{ fontSize: '10px', marginTop: '5px', color: '#999' }}>
                {categoryInfo.details}
            </div>
        </div>
    );
    
    return (
        <Popup
            trigger={<span className="category-label">{normalizedCategory}</span>}
            content={tooltipContent}
            position="top center"
            size="small"
            hoverable
            style={{
                backgroundColor: '#e0e0e0',
                color: '#000',
                border: '1px solid #999',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
            }}
        />
    );
};

export default GreaterOfBadge;
